// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_splidejs_splide_dist_js_splide_esm_js","src_js_components_bottom-navbar_js-src_js_components_menu_js"], function() { return __webpack_require__("./src/js-new/main.js"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
